"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STABLE_FACTORIES = exports.V2_FACTORIES = exports.LIQUIDATION_FEE_FACTORIES = exports.OLD_KINK_MULTIPLIER_FACTORIES = exports.BORROW_FEE_FACTORIES = exports.SOLIDEX_FACTORIES = void 0;
const types_1 = require("./types");
exports.SOLIDEX_FACTORIES = [
    types_1.Factory.SOLV1_2,
    types_1.Factory.SOLV2,
    types_1.Factory.SOL_STABLE,
];
exports.BORROW_FEE_FACTORIES = [
    types_1.Factory.V2V1,
    types_1.Factory.V2V1_1,
];
exports.OLD_KINK_MULTIPLIER_FACTORIES = [
    types_1.Factory.V2V1,
    types_1.Factory.V2V1_1,
];
exports.LIQUIDATION_FEE_FACTORIES = [
    types_1.Factory.V2V2,
    types_1.Factory.SOLV2,
    types_1.Factory.SOL_STABLE,
];
exports.V2_FACTORIES = [
    types_1.Factory.V2V2,
    types_1.Factory.SOLV2,
    types_1.Factory.SOL_STABLE,
];
exports.STABLE_FACTORIES = [
    types_1.Factory.SOL_STABLE,
];
